export default "__VITE_ASSET__B$EPCm70__"